var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasOneShowingChildren(_vm.menuItem.children) &&
    _vm.hasPermission(_vm.menuItem) &&
    !_vm.menuItem.hidden
    ? _c(
        "Submenu",
        { attrs: { name: _vm.menuItem.path || _vm.menuItem.name } },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _vm.menuItem.meta && _vm.menuItem.meta.icon
                ? _c("svg-icon", {
                    attrs: { "icon-class": _vm.menuItem.meta.icon }
                  })
                : _vm._e(),
              _vm.menuItem.meta && _vm.menuItem.meta.title
                ? _c("span", { attrs: { title: _vm.menuItem.meta.title } }, [
                    _vm._v(_vm._s(_vm.menuItem.meta.title))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._l(_vm.menuItem.children, function(child) {
            return [
              _vm.hasMenuPermission(child) && !child.hidden && !child.children
                ? [
                    _c(
                      "MenuItem",
                      {
                        key: child.path,
                        attrs: {
                          name: _vm.menuItem.path + "/" + child.path,
                          to: _vm.menuItem.path + "/" + child.path,
                          "active-name": _vm.$route.path
                        }
                      },
                      [
                        child.meta && child.meta.icon
                          ? _c("svg-icon", {
                              attrs: { "icon-class": child.meta.icon }
                            })
                          : _vm._e(),
                        child.meta && child.meta.title
                          ? _c(
                              "span",
                              {
                                staticClass: "subMenu",
                                attrs: { title: child.meta.title }
                              },
                              [_vm._v(_vm._s(child.meta.title))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ]
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }